import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import apiService from '../../services/apiService';
import TenantHeader from './TenantHeader';
import NewChatButtons from './NewChatButtons';
import AdminSection from './AdminSection';
import ConversationList from './ConversationList';
import UserFooter from './UserFooter';

const SideNav = () => {
  const { user } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  // Load user profile on mount
  useEffect(() => {
    const loadUserProfile = async () => {
      if (!user) return;
      
      try {
        const data = await apiService.get('/api/v1/users/profile', user);
        setUserProfile(data.data);
      } catch (err) {
        console.error('Error loading user profile:', err);
        // Don't show error - just use Firebase user data as fallback
      } finally {
        setProfileLoading(false);
      }
    };

    loadUserProfile();
  }, [user]);

  return (
    <div className="side-nav">
      <div className="nav-fixed-top">
        <TenantHeader userProfile={userProfile} loading={profileLoading} />
        <NewChatButtons />
        <AdminSection />
      </div>
      <div className="nav-scrollable">
        <ConversationList />
      </div>
      <UserFooter userProfile={userProfile} loading={profileLoading} />
    </div>
  );
};

export default SideNav;